if (typeof window.SEARCH_CONSTANTS === 'undefined') {
	window.SEARCH_CONSTANTS = {
		DEBOUNCE_DELAY: 500,
		SELECTOR: {
			SEARCH_INPUT: 'input[type="search"]',
			SEARCH_RESULTS: '[data-predictive-search-results]',
			EMPTY_RESULTS: '[data-search="default"]',
			NO_RESULTS: '[data-search="empty"]',
			PRODUCTS_GRID: '.header-search__modal-grid',
			LOADING: '[data-search="loading"]'
		}
	};
}

if (!customElements.get('predictive-search')) {
	customElements.define('predictive-search', class PredictiveSearch extends HTMLElement {
		constructor() {
			super();
			this.cachedResults = new Map();
			this.init();
		}

		init() {
			this.input = this.querySelector(window.SEARCH_CONSTANTS.SELECTOR.SEARCH_INPUT);
			this.predictiveSearchResults = this.querySelector(window.SEARCH_CONSTANTS.SELECTOR.SEARCH_RESULTS);
			this.sectionId = 'predictive-search';

			if (!this.input || !this.predictiveSearchResults) {
				return;
			}

			this.setupEventListeners();
		}

		setupEventListeners() {
			const debounceFn = window.debounce || ((fn) => fn);

			const debouncedSearch = debounceFn(
				(event) => this.handleSearchInput(),
				window.SEARCH_CONSTANTS.DEBOUNCE_DELAY
			).bind(this);

			this.input.addEventListener('input', debouncedSearch);
			this.input.addEventListener('keydown', (event) => {
				if (event.key !== 'Enter') return;
				event.preventDefault();
				window.location.href = '/collections/shop';
			});
		}

		handleSearchInput() {
			const searchTerm = this.input.value.trim();
			const selectors = window.SEARCH_CONSTANTS.SELECTOR;

			if (!searchTerm) {
				this.querySelector(selectors.EMPTY_RESULTS)?.classList.remove('hidden');
				this.querySelector(selectors.PRODUCTS_GRID)?.classList.add('hidden');
				this.querySelector(selectors.NO_RESULTS)?.classList.add('hidden');
				return;
			}

			const cleanTerm = searchTerm.replace(/[^\w\s\u0400-\u04FF\u0600-\u06FF]/g, "");
			console.log(cleanTerm);
			if (!cleanTerm) {
				this.querySelector(selectors.EMPTY_RESULTS)?.classList.add('hidden');
				this.querySelector(selectors.PRODUCTS_GRID)?.classList.add('hidden');
				this.querySelector(selectors.NO_RESULTS)?.classList.remove('hidden');
				return;
			}

			this.getSearchResults(searchTerm);
		}

		async getSearchResults(searchTerm) {
			const queryKey = searchTerm.toLowerCase().replace(/\s+/g, '-') || 'EMPTY_SEARCH';
			const selectors = window.SEARCH_CONSTANTS.SELECTOR;

			if (this.cachedResults.has(queryKey)) {
				this.renderSearchResults(this.cachedResults.get(queryKey));
				return;
			}

			this.querySelector(selectors.EMPTY_RESULTS)?.classList.add('hidden');
			this.querySelector(selectors.PRODUCTS_GRID)?.classList.add('hidden');
			this.querySelector(selectors.NO_RESULTS)?.classList.add('hidden');
			this.querySelector(selectors.LOADING)?.classList.remove('hidden');

			try {
				const isArabic = document.documentElement.getAttribute('lang') === 'ar';
				let url, searchParams;

				const routes = window.routes || {};

				if (isArabic) {
					url = routes.search_url || '/search';
					searchParams = new URLSearchParams({
						q: searchTerm,
						type: 'product',
						section_id: this.sectionId
					});
				} else {
					url = routes.predictive_search_url || '/search/suggest';
					searchParams = new URLSearchParams({
						q: searchTerm,
						'resources[type]': 'product,query,collection',
						'resources[limit]': '10',
						section_id: this.sectionId
					});
				}

				const response = await fetch(`${url}?${searchParams}`);

				if (!response.ok) {
					throw new Error(`Search request failed: ${response.status}`);
				}

				const text = await response.text();
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const resultsMarkup = doc.querySelector(selectors.SEARCH_RESULTS)?.innerHTML;

				if (!resultsMarkup) {
					this.querySelector(selectors.NO_RESULTS)?.classList.remove('hidden');
					return;
				}

				this.cachedResults.set(queryKey, resultsMarkup);
				this.renderSearchResults(resultsMarkup);

				if (typeof initCountsInDom === 'function') {
					initCountsInDom(this.predictiveSearchResults);
				}

				this.querySelector(selectors.PRODUCTS_GRID)?.classList.remove('hidden');
				this.querySelector(selectors.EMPTY_RESULTS)?.classList.add('hidden');

			} catch (error) {
				console.error('Search error:', error);
				this.showErrorState();
			} finally {
				this.querySelector(selectors.LOADING)?.classList.add('hidden');
			}
		}

		renderSearchResults(resultsMarkup) {
			if (!resultsMarkup?.trim()) return;

			this.predictiveSearchResults.innerHTML = resultsMarkup;
			if (typeof updateProductForm === 'function') {
				updateProductForm();
			}
		}

		showErrorState() {
			console.error("Sorry, something went wrong. Please try again.");
		}
	});
}